module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq413-0f1c6a1e9ec1cea6454500cf7ba7d093.jpg";